import * as FullStory from '@fullstory/browser';
import * as Sentry from '@sentry/react';

import { GetCompanyQuery, GetUserQuery } from '@neo.tax/shared/graphql/types';
import { IdentifiableUser } from '@neo.tax/shared/initialization';
import { env, isLocalEnvironment } from '@neo.tax/shared/utils';

const FULLSTORY_ORG_ID = env.REACT_APP_FS_ORG_ID;

export const initializeFullStory = (): void => {
  FullStory.init({ orgId: FULLSTORY_ORG_ID }, ({ sessionUrl }) => {
    Sentry.setTag('fullstory-url', sessionUrl);
  });
};

export const identifyFullStoryUser = (identifiableUser: IdentifiableUser): void => {
  const { email, firebaseUserId, fullName } = identifiableUser;
  FullStory.identify(firebaseUserId, {
    displayName: fullName,
    email,
  });
};

export const sendFSEvent = (
  eventName: string,
  eventData: Record<string, unknown>,
  currentUser: GetUserQuery['getUser'] | null,
  company: GetCompanyQuery['getCompany'] | null,
): void => {
  if (!isLocalEnvironment()) {
    if (!currentUser) {
      // When user isn't signed in, send FS event without `user_obj`.
      FullStory.event(eventName, {
        ...(eventData && { ...eventData }),
      });
    } else {
      const { email, firebaseUserId, fullName, id, phone } = currentUser;
      let companyData = null;
      if (company) {
        const { id: companyID, shortName } = company;
        companyData = {
          company_id_str: companyID,
          company_legal_name_str: shortName,
        };
      }
      FullStory.event(eventName, {
        user_obj: {
          user_id_str: id,
          user_firebase_id_str: firebaseUserId,
          user_full_name_str: fullName,
          user_email_str: email,
          user_phone_number_str: phone,
          ...(companyData && { user_company_obj: companyData }),
        },
        ...(eventData && { ...eventData }),
      });
    }
  }
};

export const clearFullStory = (): void => {
  FullStory.anonymize();
};
